import * as Users from '../Users';
import { notify, loading, closeLoding } from '@/helpers/$vs';
import { ROLES } from '@/constants/index.js';
import store from '@/store';

export default {
	async getAllUsers({commit, state, dispatch}) {      
        try {
            loading('sound');
            const result = await Users.getAllUsers();
            const _roles = ROLES[store.state.user.roleName];
            const originList = result.filter(user => _roles.includes(user.roleName));  
            commit('LIST_USERS',originList);      
        } catch (error) {
            notify(
                'Usuarios', 
                `Ocurrio un error, al consultar la lista de Usuarios${error.message}`,
                'warning',
                'top-right',               
                'error');            
        } finally {
            closeLoding();
        }
	},
    async getRoles({commit, state, dispatch}) {      
        try {
            const result = await Users.getRoles();
            const _roles = ROLES[store.state.user.roleName]; 
            const listRoles = result
                            .filter(rol => _roles.includes(rol.name) && rol.status === 'Active')
                            .map(rol => { return {value: rol.key, label: rol.name } } );  
            commit('LISTA_ROLES',listRoles);      
        } catch (error) {
            notify(
                'Usuarios', 
                `Ocurrio un error, al consultar la lista de Roles${error.message}`,
                'warning',
                'top-right',               
                'error');            
        }
	},

    async getUserInfo({commit, state, dispatch}, id) {
        try{
            const userInfo = await Users.getOneUser(id);
            const  { username, name,  lastname, email, status, roleName, roleID, companyID, picture } = userInfo;
            console.log('userInfo userInfo userInfo ',userInfo)
            const data = { username, name,  lastname, email, status, roleName, roleID, companyID, picture };
            commit('INFO_USER', data);
        }catch(error) {
            console.log('Error ',error)
        }
    }
	
}